import { api } from '../client';
import type {
  DocumentTypeTreeResponse,
  FormSchemaResponse,
  DocumentTypeTransitionDto,
} from '../generated/schema';

export async function getDocumentTypeTree(): Promise<DocumentTypeTreeResponse> {
  return api.get<DocumentTypeTreeResponse>('api/console/document-types/tree');
}

export async function getDocumentSchema(
  typeCode: string,
  version?: number,
): Promise<FormSchemaResponse> {
  const suffix = version != null ? `?version=${version}` : '';
  return api.get<FormSchemaResponse>(`api/console/document-types/${typeCode}/schema${suffix}`);
}

export async function getDocumentTypeTransitions(
  typeCode: string,
): Promise<DocumentTypeTransitionDto[]> {
  return api.get<DocumentTypeTransitionDto[]>(`api/console/document-types/${typeCode}/transitions`);
}
